import React, { useState, useEffect } from 'react';
import Main from '../componentes/Main';
import Axios from 'axios';
import { Grid } from "@material-ui/core";
import { Spinner, Card, Typography, Input, IconButton, Button, Dialog, DialogHeader, DialogBody, DialogFooter, Checkbox } from '@material-tailwind/react';
import { MagnifyingGlassIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import Swal from 'sweetalert2';
import ExportToExcelBancos from '../componentes/exportExcelCajasRubros';
import { useContextoGlobal } from '../Context/contextoGlobal';
import { ListadoCelular } from '../componentes/ListadoCelular';

export default function Bancos({ usuario }) {

    const [bancosList, setBancosList] = useState([])
    const [name, setName] = useState('')
    const [bancoId, setBancoId] = useState(0)
    const [abreviatura, setAbreviatura] = useState('')
    const [nameSearch, setNameSearch] = useState('')
    const [buscandoDatos, setBuscandoDatos] = useState(false)
    const [open, setOpen] = React.useState(false);
    const [ingreso, setIngreso] = React.useState(false);
    const [egreso, setEgreso] = React.useState(false);
    const { esCelular } = useContextoGlobal();

    useEffect(() => {
        obtenerArchivos()
    }, [])

    const handleOpen = () => setOpen(!open);

    const obtenerArchivos = async () => {
        setBuscandoDatos(true);
        try {
            const resultList = await Promise.all([Axios.get(`/api/tablasgenerales/bancos`)])
            setBancosList(resultList[0].data.recordset)
            setBuscandoDatos(false);
        } catch (err) {
            console.log(err)
            setBuscandoDatos(false);
        }
    }

    const verBancoSeleccionado = async (e) => {
        try {
            const banco = await Promise.all([Axios.get(`/api/tablasgenerales/banco/${e.id_banco}`)])
            const bancoSeleccionada = banco[0].data.recordset[0];
            setBancoId(bancoSeleccionada.id_banco);
            setName(bancoSeleccionada.nombre);
            setAbreviatura(bancoSeleccionada.abreviatura);
            setIngreso(bancoSeleccionada.ingreso);
            setEgreso(bancoSeleccionada.egreso);
            handleOpen();
        } catch (error) {
            console.log(error)
            setBuscandoDatos(false);
        }
    }

    const borrarBanco = async (e) => {
        Swal.fire({
            title: "Esta seguro que desea Eliminarlo?",
            text: "Este cambio es irreversible!",
            type: "warning",
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: "No, cancelar!",
            showCancelButton: true,
            // allowOutsideClick: false
        }).then(
            async resultado => {
                if (resultado.value) {
                    try {
                        await Promise.all([Axios.delete(`/api/tablasgenerales/banco/${e.id_banco}`)]);
                        obtenerArchivos();
                    } catch (error) {
                        console.log(error)
                        setBuscandoDatos(false);
                    }
                }
            }
        )

    }

    const handleCheckAmbos = () => {
        setIngreso(true);
        setEgreso(true);
    }

    const handleIngreso = () => {
        setIngreso(!ingreso);
        setEgreso(false);
    }

    const handleEgreso = () => {
        setEgreso(!egreso);
        setIngreso(false);
    }

    const editarBanco = async () => {
        const datos = {
            nombre: name,
            abreviatura: abreviatura,
            ingreso: ingreso,
            egreso: egreso
        }

        try {
            await Promise.all([Axios.put(`/api/tablasgenerales/banco/${bancoId}`, datos)])
            Swal.fire({
                icon: 'alert',
                title: `<p>Los datos han sido actualizados con éxito</p>`,
            })
            handleOpen();
            obtenerArchivos();
        } catch (error) {
              Swal.fire({
                icon: 'alert',
                title: `<p>Error al actualizar los Datos</p>`,
                showCancelButton: true,
            })
            console.log(error)
        }
    }

    const limpiarBusqueda = async () => {
        obtenerArchivos();
        setNameSearch('')
    }

    const handleSearchData = async () => {
        if (nameSearch.trim() === '') {
            setBancosList(bancosList);
        } else {
            const listaFiltrada = bancosList.filter(item =>
                item.nombre.toLowerCase().includes(nameSearch.toLowerCase())
            );
            setBancosList(listaFiltrada.length > 0 ? listaFiltrada : bancosList);
        }
    }

   const verCrearBanco = async () => {
        try {
            setBancoId(0);
            setName('');
            setAbreviatura('');
            setEgreso(false);
            setIngreso(false);
            handleOpen();
        } catch (error) {
            console.log(error)
            setBuscandoDatos(false);
        }
    }

    const crearBanco = async () => {
          try {
            let data = {
                nombre: name,
                abreviatura: abreviatura,
                ingreso: ingreso,
                egreso: egreso
            }
            await Promise.all([Axios.post(`/api/tablasgenerales/banco/`, data)])
            Swal.fire({
                icon: 'alert',
                title: `<p>El banco ha sido creado con éxito</p>`,
            })
            handleOpen();
            obtenerArchivos();
        } catch (error) {
            Swal.fire({
                icon: 'alert',
                title: `<p>Error al crear los Datos</p>`,
                showCancelButton: true,
            })
            console.log(error)
            setOpen(true);
        }
    }

    if (buscandoDatos) {
        return <Main center alinear>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <Spinner className="h-12 w-12" />
                <span className="cargando font-semibold text-[15px]">Cargando archivos...</span>
            </div>
        </Main>
    }

    if (bancosList.length == 0) {
        return <Grid container justifyContent='center' alignItems='center' style={{ minHeight: '400px', textAlign: 'center' }} >
            <Grid item>
                <Typography variant="h5">
                    No se encontraron archivos
                </Typography>
            </Grid>
        </Grid>
    }

    return <div className='w-full flex flex-col justify-center items-center lg:!m-6 xl:!m-6'>
        <Typography variant="h4" className="flex ">
            Bancos
        </Typography>
        <Card className='w-full justify-center items-center flex p-5 justify-left mt-4'>
            <div className='w-full lg:w-96 xl:w-96 relative'>
                <Input
                    type="text"
                    label="Buscar nombre del banco"
                    value={nameSearch}
                    onChange={(e) => { setNameSearch(e.target.value) }}
                    color='black'
                />
                <Button
                    size="sm"
                    color={nameSearch ? "blue" : "blue-gray"}
                    disabled={!nameSearch}
                    className="!absolute right-1 top-1 rounded flex"
                    onClick={handleSearchData}
                >
                    <MagnifyingGlassIcon className="h-4 w-4 mr-2" />Buscar
                </Button>
            </div>
            {bancosList.length > 0 && <div className='mt-8 w-full'>
                 <div className="flex flex-col md:flex-row gap-2 xl:!justify-end">
                    <Button className="flex md:ml-2 justify-center gap-3 bg-green-500" onClick={verCrearBanco}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="h-4 w-4"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 4.5v15m7.5-7.5h-15"
                            />
                        </svg>
                        Crear
                    </Button>
                    <Button variant='text' className='text-red-400 bg-red-100 hover:bg-red-200' onClick={limpiarBusqueda}>Limpiar Busqueda</Button>
                    <ExportToExcelBancos data={bancosList} fileName="Listado de Bancos" />
                </div>
                <Typography
                    variant="small"
                    color="blue-gray"
                    className="font-normal leading-none hidden lg:flex"
                >
                    Se han encontrado {bancosList.length} Bancos
                </Typography>

                {esCelular ? 
                  <ListadoCelular datos={bancosList} verSeleccionado={verBancoSeleccionado} borrar={borrarBanco} />
                    :
                  <table className="w-full min-w-max table-auto text-left mt-2">
                      <thead>
                          <tr>
                              <th
                                  className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                              >
                                  <Typography
                                      variant="small"
                                      color="blue-gray"
                                      className="font-normal leading-none opacity-70"
                                  >
                                      Nombre
                                  </Typography>
                              </th>
                              <th
                                  className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                              >
                                  <Typography
                                      variant="small"
                                      color="blue-gray"
                                      className="font-normal leading-none opacity-70"
                                  >
                                      Abreviatura
                                  </Typography>
                              </th>
                              <th
                                  className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                              >
                                  <Typography
                                      variant="small"
                                      color="blue-gray"
                                      className="font-normal leading-none opacity-70"
                                  >
                                      Tipo de Movimiento
                                  </Typography>
                              </th>
                              <th
                                  className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                              >
                                  <Typography
                                      variant="small"
                                      color="blue-gray"
                                      className="font-normal leading-none opacity-70"
                                  >
                                      Acciones
                                  </Typography>
                              </th>
                          </tr>
                      </thead>
                      <tbody>
                          {bancosList.map((item, index) => {
                              const isLast = index === bancosList.length - 1;
                              const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

                              return (
                                  <tr key={index}>
                                      <td className={classes}>
                                          <Typography
                                              variant="small"
                                              color="blue-gray"
                                              className="font-normal"
                                          >
                                              {item.nombre}
                                          </Typography>
                                      </td>
                                      <td className={classes}>
                                          <Typography
                                              variant="small"
                                              color="blue-gray"
                                              className="font-normal"
                                          >
                                              {item.abreviatura}
                                          </Typography>
                                      </td>
                                      <td className={classes}>
                                          <Typography
                                              variant="small"
                                              color="blue-gray"
                                              className="font-normal"
                                          >
                                              {item.tipo_movimiento}
                                          </Typography>
                                      </td>
                                      <td className={classes}>
                                          <div className="flex items-center gap-2">
                                              <IconButton variant="text" size="sm" onClick={() => verBancoSeleccionado(item)}>
                                                  <PencilIcon className="h-4 w-4 text-gray-900" />
                                              </IconButton>
                                              <IconButton variant="text" size="sm" onClick={() => borrarBanco(item)}>
                                                  <TrashIcon className="h-4 w-4 text-gray-900" />
                                              </IconButton>
                                          </div>
                                      </td>
                                  </tr>
                              );
                          })}
                      </tbody>
                  </table>
                }

            </div>}
        </Card>
        <Dialog open={open} handler={handleOpen}>
            <DialogHeader>Unión de las Asambleas de Dios</DialogHeader>
            <DialogBody className="xl:p-10">
                <div className="flex flex-col w-full mt-4">
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="mb-1 font-medium "
                    >
                        Nombre
                    </Typography>
                    <Input
                        onChange={(e) => {
                            setName(e.target.value)
                        }}
                        value={name}
                        type='text'
                        id='name'
                        name='name'
                        color='black'
                        className="!border-t-blue-gray-200 focus:!border-t-gray-900"
                        labelProps={{
                            className: "before:content-none after:content-none",
                        }}
                    />
                </div>
                <div className="flex flex-col w-full mt-4">
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="mb-1 font-medium"
                    >
                        Abreviatura
                    </Typography>
                    <Input
                        onChange={(e) => {
                            setAbreviatura(e.target.value)
                        }}
                        value={abreviatura}
                        type='text'
                        id='name'
                        name='name'
                        color='black'
                        className="!border-t-blue-gray-200 focus:!border-t-gray-900"
                        labelProps={{
                            className: "before:content-none after:content-none",
                        }}
                    />
                </div>
                <div className="grid grid-cols-3 justify-left mt-2">
                    <Typography variant="small" color="blue-gray" className="mt-4 font-medium">
                        Tipo de Movimiento
                    </Typography>
                    <div className="col-span-2 flex md:space-x-2 w-full mt-1">
                        <Checkbox
                            label="Ingreso"
                            ripple={false}
                            checked={ingreso}
                            onClick={handleIngreso}
                            className='w-5 h-5 md:pl-2'
                        />
                        <Checkbox
                            label="Egreso"
                            ripple={false}
                            checked={egreso}
                            onClick={handleEgreso}
                            className='w-5 h-5'
                        />
                        {/*<Checkbox
                            label="Ingreso y Egreso"
                            ripple={false}
                            onClick={handleCheckAmbos}
                            checked={ingreso && egreso}
                            className='w-5 h-5'
                        />*/}
                    </div>
                </div>
            </DialogBody>
            <DialogFooter className="space-x-2">
                <Button 
                    variant="gradient" 
                    color="blue" 
                    onClick={() => bancoId !== 0 ? editarBanco() : crearBanco()}
                    >
                        Guardar
                </Button>
                <Button variant="text" color="blue-gray" onClick={handleOpen}>
                    Cancelar
                </Button>
            </DialogFooter>
        </Dialog>
    </div>
}